import { Link } from "react-router-dom";
import content from "@/content/siteContent";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="border-t border-plz-line/60 bg-plz-navy/40">
      <div className="mx-auto max-w-7xl px-4 py-16 sm:px-6 lg:px-8">
        <div className="grid gap-12 md:grid-cols-3">
          <div>
            <p className="font-heading text-lg font-extrabold tracking-tight">
              PLZ<span className="mx-[3px] inline-block h-[7px] w-[7px] rounded-full bg-plz-orange" aria-hidden="true" />Company
            </p>
            <p className="mt-4 max-w-xs text-sm leading-relaxed text-plz-muted">{content.footer.tagline}</p>
          </div>
          <nav aria-label="Footer" className="flex flex-col gap-3">
            <p className="font-mono text-xs uppercase tracking-[0.25em] text-plz-orange">Explore</p>
            {content.nav.map((item) => (
              <a key={item.target} href={item.target} data-testid={`footer-link-${item.target.slice(1)}`}
                className="text-sm text-plz-slate transition-colors hover:text-plz-cream">
                {item.label}
              </a>
            ))}
          </nav>
          <div className="flex flex-col gap-3">
            <p className="font-mono text-xs uppercase tracking-[0.25em] text-plz-orange">Contact</p>
            <a href={`mailto:${content.footer.contactEmail}`} data-testid="footer-email-link"
              className="text-sm text-plz-slate transition-colors hover:text-plz-cream">
              {content.footer.contactEmail}
            </a>
            <Link to="/privacy" data-testid="footer-privacy-link"
              className="text-sm text-plz-slate transition-colors hover:text-plz-cream">
              Privacy Policy
            </Link>
          </div>
        </div>
        <div className="mt-14 flex flex-col items-center justify-between gap-4 border-t border-plz-line/40 pt-8 sm:flex-row">
          <p className="text-xs text-plz-muted">
            &copy; {new Date().getFullYear()} {content.footer.copyright}
          </p>
          <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-plz-muted">
            {content.brand.tagline}
          </p>
        </div>
      </div>
    </footer>
  );
}
